<script setup>

import EnterId from "./EnterId.vue";

import EnterPassword from "./EnterPassword.vue";

import { useLogin } from "./business_logic";

import { requestStatus } from "@/utils/constants";

import Otp from "../otp/index.vue";

import { computed } from "vue";

import { countyIsKirinyaga } from "@/utils/vue_helpers";



const {

  loginModels,

  authenticateUserRequestStatus,

  logUserIn,

  authenticateUser,

  otpData,

  logUserInRequestStatus,

  transitionClass,

  isCurrentView,

  otpInvalid,

  checkAccount,

  checkAccountRequestStatus,

  userIdNotInSystem,

  goTo,

  resetOtpStatusToInitial,

  continueAsClient,

  continueAsProfessional,

  professionalDisplayRole,

} = useLogin();



const loggingUserIn = computed(() => {

  return logUserInRequestStatus.value === requestStatus.SENDING;

});

</script>



<template>

  <div class="pl-md-10">

    <div :class="{

      'text-h6 primary--text mb-md-8 mt-4 mt-md-0': true,

      'text-center': $mobileBreakpoint,

    }">

      Login

    </div>

    <transition :name="transitionClass" mode="out-in">

      <EnterId v-if="isCurrentView.enterId.value" key="userNotIdentified" :loginModels="loginModels"

        :checkAccountRequestStatus="checkAccountRequestStatus" :userIdNotInSystem.sync="userIdNotInSystem"

        @check-account="checkAccount" />



      <EnterPassword v-else-if="isCurrentView.enterPassword.value" key="userNotAuthenticated" :loginModels="loginModels"

        :authenticateUserRequestStatus="authenticateUserRequestStatus" @authenticate-user="authenticateUser"

        @back-clicked="goTo.enterId" />



      <v-container v-else-if="isCurrentView.otp.value" key="otpVerification" fluid class="">

        <v-row class="mb-md-4">

          <v-col cols="12" class="pl-0">

            <div :class="{

              'text-body-2 text-md-h6 primary--text': true,

              'text-center': $mobileBreakpoint,

            }">

              Enter Verification Code to proceed

            </div>

          </v-col>

        </v-row>

        <v-row>

          <v-col cols="12" class="pr-2 pl-md-0">

            <Otp :phoneNumber="otpData.phoneNumber" :countryCode="otpData.countryCode" :emailAddress="otpData.email"

              :idNumber="loginModels.idNumber" :verifying="loggingUserIn" usingIdNumber @verifyOtpClicked="logUserIn"

              :otpInvalid="otpInvalid" :resetOtpStatusToInitialFn="resetOtpStatusToInitial"

              :sendOtpImmediately="countyIsKirinyaga" />

          </v-col>

        </v-row>

        <v-row justify="center" justify-md="start" class="mt-md-4">

          <v-col cols="auto" class="pl-md-0">

            <v-btn outlined rounded depressed block class="text-none" @click="goTo.enterId()">

              <v-icon :small="$mobileBreakpoint" left>mdi-arrow-left</v-icon>

              <span class="text-caption text-md-body-2">Back to Enter ID Number</span>

            </v-btn>

          </v-col>

        </v-row>

      </v-container>



      <v-container v-else-if="isCurrentView.choosePortalMode.value" key="choosePortalMode" fluid class="">

        <v-row class="mb-md-4">

          <v-col cols="12" class="pl-0">

            <div :class="{

              'text-body-2 text-md-h6 primary--text': true,

              'text-center': $mobileBreakpoint,

            }">

              How would you like to continue?

            </div>

          </v-col>

        </v-row>

        <v-row>

          <v-col cols="12" md="8" class="pl-0">

            <v-btn

              rounded

              block

              depressed

              color="secondary"

              class="text-none mb-4"

              @click="continueAsClient"

            >

              Continue as County Client

            </v-btn>

            <v-btn

              rounded

              block

              outlined

              color="primary"

              class="text-none"

              @click="continueAsProfessional"

            >

              Continue as {{ professionalDisplayRole }}

            </v-btn>

          </v-col>

        </v-row>

      </v-container>

    </transition>



    <div class="mt-12 text-caption">

      <div>For any enquiries, please reach us via:

      </div>

      <div class="d-flex flex-column mt-2 text-caption" :style="{ gap: '4px' }">

        <div>CALL/SMS/WHATSAPP: 0759 674392</div>

        <div>WhatsApp: <a target="_blank" href="https://wa.me/254759674392">https://wa.me/254759674392</a></div>

        <div>Email: <a target="_blank" href="mailto:revenue@kirinyaga.go.ke">revenue@kirinyaga.go.ke</a></div>

        <div>
          Mobile application:
          <a href="https://play.google.com/store/apps/details?id=go.ke.kirinyaga.kiripay" target="_blank" class="primary--text">My Kirinyaga app</a>
        </div>
      </div>

    </div>

  </div>

</template>



<style scoped>

.to-login-enter-active,

.to-login-leave-active,

.to-verify-enter-active,

.to-verify-leave-active {

  transition: transform 0.3s ease-out, opacity 0.3s ease-out;

}



.to-verify-enter {

  transform: translateX(-20px);

  opacity: 0;

}



.to-verify-leave-to {

  transform: translateX(20px);

  opacity: 0;

}



.to-login-enter {

  transform: translateX(20px);

  opacity: 0;

}



.to-login-leave-to {

  transform: translateX(-20px);

  opacity: 0;

}

</style>

